import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-student-enroll",
  "use": "icon-student-enroll-usage",
  "viewBox": "0 0 128 128",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\" id=\"icon-student-enroll\">\n  <circle cx=\"64\" cy=\"40\" r=\"20\" fill=\"currentColor\" opacity=\"0.6\" />\n  <path d=\"M64 70c-18 0-32 14-32 32v18h64v-18c0-18-14-32-32-32z\" fill=\"currentColor\" opacity=\"0.4\" />\n  <rect x=\"85\" y=\"25\" width=\"25\" height=\"20\" rx=\"4\" fill=\"currentColor\" opacity=\"0.8\" />\n  <text x=\"97\" y=\"38\" text-anchor=\"middle\" font-size=\"16\" fill=\"white\">+</text>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol